import styled, { css } from 'styled-components';
import { transparentize } from 'utils/color';
import media from 'components/mixins/media';

export const TabWrapper = styled.div`
  display: flex;
`;

export const TabNavWrapper = styled.div`
  position: relative;
  width: 30%;
  font-family: 'Qanelas-Soft', 'IowanOldSt-BT', 'PT Serif', serif;
  font-size: 18px;
  font-weight: 600;

  .ScrollbarsCustom-Scroller,
  .ScrollbarsCustom-Wrapper {
    top: 0 !important;
    right: -2px !important;
    bottom: 0 !important;
    left: 0 !important;
  }
  .ScrollbarsCustom-Scroller {
    right: 0 !important;
  }
  .ScrollbarsCustom-TrackY {
    width: 8px !important;
    top: 0 !important;
    right: 4px !important;
    background: transparent !important;
    .ScrollbarsCustom-ThumbY {
      background-color: ${props =>
        transparentize(`${props.theme.colors.textColor}`, 0.2)} !important;
      border-radius: 6px !important;
      &:hover {
        background-color: ${props =>
          transparentize(`${props.theme.colors.textColor}`, 0.4)} !important;
      }
    }
  }
`;

type TabProps = {
  isActive: boolean;
  tabIndex?: number;
};

export const TabNav = styled.div.attrs((props: TabProps) => ({
  tabIndex: props.tabIndex
}))<TabProps>`
  position: relative;
  padding: 25px 0;
  width: 238px;
  border-bottom: 1px solid #eaebed;
  cursor: pointer;
  opacity: 0.5;

  &:hover {
    opacity: 0.7;
  }

  ${props =>
    props.isActive &&
    css`
      opacity: 1;
      &:hover {
        opacity: 1;
      }
      h4 {
        &:before {
          content: '';
          position: absolute;
          top: 0;
          right: -27px;
          height: 100%;
          width: 2px;
          background-color: ${props.theme.colors.mainColor};
        }
      }
    `}

  ${media.xlarge`
        width: 200px;
    `}
`;

export const TabNavShadow = styled.div<TabProps>`
  width: calc(100% - 24px);
  height: 1px;
  background-color: rgba(0, 0, 0, 0.04);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
  visibility: hidden;

  &.bottom-line {
    box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.2);
  }

  ${props =>
    props.isActive &&
    css`
      visibility: visible;
    `}
`;

export const TabContentWrapper = styled.div`
  width: 70%;
  padding-left: 42px;
  border-left: 2px solid #f7f7f8;
`;

export const TabContent = styled.div`
  margin-bottom: 49px;
  opacity: 1;
  transition: opacity 0.3s;

  & > ul {
    padding-left: 0;

    & > li:before {
      display: none;
    }
  }

  &.exit-active,
  &.enter {
    opacity: 0;
  }
`;
